import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import {OauthService} from '../../../shared/services/oauth.service';
import {App} from 'ionic-angular';
import {Headers, Http} from '@angular/http';
import {AuthService} from '../../../shared';
import {EnvironnementProvider} from '../../../core/app/environnement-provider.service';
import {AppProvider} from '../../../core/app/app-provider.service';
import {ToolsService} from '../../../shared/services/tools.service';

@Injectable()
export class LoginService extends OauthService {
    constructor(
        protected http: Http,
        protected app: App,
        public authService: AuthService,
        private environnementProvider: EnvironnementProvider,
        protected appProvider: AppProvider,
        public readonly tools: ToolsService,
    ) {
        super(http, app, appProvider, tools);
    }

    /**
     * @param credentials
     * @returns {Promise<any>}
     */
    login(credentials): Promise<any> {

        let url = this.Routing.generate('fos_oauth_server_token', {'_format': 'json'}, true);
        url += '&version=' + this.appProvider.version;
        let formData: string;
        credentials.client_id = this.environnementProvider.default.client_id;
        credentials.client_secret = this.environnementProvider.default.client_secret;
        credentials.grant_type = 'password';
        credentials.web = this.appProvider.web;
        formData = this.getFormData(credentials);

        return new Promise((resolve, reject) => {
            this.http
                .post(url, formData, {headers: this.formDataHeaders})
                .map(res => res.json())
                .subscribe(data => {
                    this.tools.localStorageService.setOauthToken(data);
                    if (!data.need_2fa) {
                      this.authService.identity(true).then(() => {
                        resolve(data);
                      });
                    } else {
                      resolve(data);
                    }
                }, error => {
                  reject(error);
                });
        });
    }

  code2FA(code): Promise<any> {

    const url = this.Routing.generate('fos_oauth_server_code', {'_format': 'json'}, true);

    const credentials: any = {};
    credentials.code = code;

    return new Promise((resolve, reject) => {
      this.http
        .post(url, credentials, {headers: this.updateHeaders()})
        .map(res => res.json())
        .subscribe(data => {
          this.authService.identity(true).then(() => {
            resolve(data);
          });
        }, error => {
          reject(error);
        });
    });
  }

  updateHeaders(param = null): Headers {
    const headers = this.getHeaders(param);
    return new Headers(headers);
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/services/login.service.ts